module.exports = __webpack_public_path__ + "img/2.33031da4.png";